import { schema } from 'normalizr'

const deliveryProductOrder = new schema.Entity('deliveryProductOrders', {})

export default deliveryProductOrder
